import Button, { BUTTON_DISPLAY, BUTTON_SIZE } from "@acadia-ui/button";
import FindReplaceModal from "../../Modals/FindReplaceModal";
import { useCallback, useMemo, useRef } from "react";
import applyFindReplaceToTable from "./applyFindReplaceToTable";

export default function useFindReplace({ dataTableApi, renderedData, config, TMEnabled, campaignMetaData }) {
	const placementFindReplace = useRef(null);

	const replaceData = (data, toggleEditing = false) => {
		applyFindReplaceToTable({
			data,
			dataTableApi,
			toggleEditing,
			clearFilters: true
		});
	};

	const displayInMoreMenu = useMemo(() => {
		const isPrisma = campaignMetaData.PlatformName === "Mediaocean (OX)/Prisma";
		return isPrisma && TMEnabled === true;
	}, [TMEnabled, campaignMetaData]);

	const Trigger = useCallback(() => {
		return (
			<Button
				// this comment exists to prevent eslint from making this unreadable.
				size={BUTTON_SIZE.SMALL}
				display={BUTTON_DISPLAY.TEXT}
				key="placement-find-replace"
				onClick={() => placementFindReplace.current.triggerOpenClose()}
				data-tracking-id-alt="open-find-replace-modal"
			>
				Find and Replace
			</Button>
		);
	}, []);

	const DisplayedComponent = useCallback(() => {
		return (
			<FindReplaceModal
				findReplaceModal={(ref) => {
					placementFindReplace.current = ref;
				}}
				type={"Placement"}
				hierarchyLevel="Placement"
				config={config}
				data={renderedData}
				replaceData={replaceData}
				tableRef={dataTableApi}
			/>
		);
	}, [dataTableApi, replaceData, renderedData, config]);

	return useMemo(() => [Trigger, DisplayedComponent, { displayInMoreMenu }], [Trigger, DisplayedComponent, displayInMoreMenu]);
}
